<div class="container">
	<form [formGroup]="formGroup" class="container__form">
		<form-section [title]="'DRAWERS.CREATION.SECTIONS.PARAMETERS' | translate">
			<form-row>
				<form-field>
					<lawyal-dropdown-input
						[formControlName]="STATUS_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.STATUS.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.STATUS.LABEL'"
						[options]="statusOptions"
					>
					</lawyal-dropdown-input>
				</form-field>
			</form-row>
			<form-row>
				<form-field>
					<lawyal-autocomplete
						[formControlName]="BRANCH_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.BRANCH.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.BRANCH.LABEL'"
						[dataSource]="autocompleteDataSource.Branch"
						[isPaginated]="true"
					>
					</lawyal-autocomplete>
				</form-field>
				<form-field>
					<lawyal-autocomplete
						[formControlName]="DEPARTMENT_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.DEPARTMENT.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.DEPARTMENT.LABEL'"
						[dataSource]="autocompleteDataSource.Departments"
						[isPaginated]="true"
						[isMultipleSelection]="true"
					>
					</lawyal-autocomplete>
				</form-field>
			</form-row>
			<form-row>
				<form-field>
					<free-text-input
						[formControlName]="NAME_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.EMPLOYEE_NAME.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.EMPLOYEE_NAME.LABEL'"
					>
					</free-text-input>
				</form-field>
				<form-field>
					<lawyal-autocomplete
						[formControlName]="ROLE_CONTROL_NAME"
						[placeholder]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.POSITION.LABEL'"
						[label]="'DRAWERS.SEARCH.CONTROLS.PARAMETER.POSITION.LABEL'"
						[dataSource]="autocompleteDataSource.Roles"
						[isPaginated]="false"
					>
					</lawyal-autocomplete>
				</form-field>
			</form-row>
			<form-row>
				<form-field>
					<free-text-input
						[formControlName]="PHONE_CONTROL_NAME"
						[placeholder]="'DRAWERS.CREATION.CONTROLS.PHONE.LABEL'"
						[label]="'DRAWERS.CREATION.CONTROLS.PHONE.LABEL'"
						[isLtr]="true"
					>
					</free-text-input>
				</form-field>
				<form-field>
					<free-text-input
						[formControlName]="EMAIL_CONTROL_NAME"
						[placeholder]="'DRAWERS.CREATION.CONTROLS.EMAIL.LABEL' | translate"
						[label]="'DRAWERS.CREATION.CONTROLS.EMAIL.LABEL' | translate"
					>
					</free-text-input>
				</form-field>
			</form-row>
		</form-section>
	</form>
	<form-actions class="container__buttons-wrapper">
		<submit-button [title]="'DRAWERS.BUTTONS.CLEAR_ALL' | translate" (onClick)="onClearAll()"></submit-button>
		<submit-button [title]="'DRAWERS.BUTTONS.SEARCH' | translate" [filled]="true" (onClick)="onSubmit()"></submit-button>
	</form-actions>
</div>
